import { IconProps } from ".";

export const Settings2Icon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M8.6447 5.54878L6.90046 5.14626C6.57358 5.07083 6.23089 5.16911 5.99368 5.40632L5.40632 5.99368C5.16911 6.23089 5.07083 6.57358 5.14626 6.90046L5.54878 8.6447C5.63978 9.03905 5.47717 9.44855 5.14043 9.67305L3.43326 10.8112C3.16258 10.9916 3 11.2954 3 11.6207V12.3793C3 12.7046 3.16259 13.0084 3.43326 13.1888L5.14043 14.327C5.47717 14.5514 5.63978 14.9609 5.54878 15.3553L5.14626 17.0995C5.07083 17.4264 5.16911 17.7691 5.40632 18.0063L5.99368 18.5937C6.23089 18.8309 6.57358 18.9292 6.90046 18.8537L8.6447 18.4512C9.03905 18.3602 9.44855 18.5228 9.67305 18.8596L10.8112 20.5667C10.9916 20.8374 11.2954 21 11.6207 21H12.3793C12.7046 21 13.0084 20.8374 13.1888 20.5667L14.327 18.8596C14.5514 18.5228 14.9609 18.3602 15.3553 18.4512L17.0995 18.8537C17.4264 18.9292 17.7691 18.8309 18.0063 18.5937L18.5937 18.0063C18.8309 17.7691 18.9292 17.4264 18.8537 17.0995L18.4512 15.3553C18.3602 14.9609 18.5228 14.5514 18.8596 14.327L20.5667 13.1888C20.8374 13.0084 21 12.7046 21 12.3793V11.6207C21 11.2954 20.8374 10.9916 20.5667 10.8112L18.8596 9.67305C18.5228 9.44855 18.3602 9.03905 18.4512 8.6447L18.8537 6.90046C18.9292 6.57358 18.8309 6.23089 18.5937 5.99368L18.0063 5.40632C17.7691 5.16911 17.4264 5.07083 17.0995 5.14626L15.3553 5.54878C14.9609 5.63978 14.5514 5.47717 14.327 5.14043L13.1888 3.43326C13.0084 3.16258 12.7046 3 12.3793 3H11.6207C11.2954 3 10.9916 3.16259 10.8112 3.43326L9.67305 5.14043C9.44855 5.47717 9.03905 5.63978 8.6447 5.54878Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};
